// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.competitiveContainer {
  width: 100%;
}
.competitiveContainer > img {
  width: 100%;
  object-fit: cover;
  height: fit-content;
}
.competitiveContainer > div {
  padding: 50px 0px 0px 0px;
  margin: auto;
  width: 80%;
  background-color: #fff;
}
.band_img_div_comp {
  width: 100%;
}

.band_img_div_comp > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.desc_text{
  color: #fff !important;
  font-family: lightThicker !important;
  font-size: clamp(16px, 4vw, 20px);
  font-weight: 400;
}
.competitiveContainer > div > div {
  margin-bottom: 50px;
}

.competitiveContainer > div > div > h1 {
  color: #000;
  font-size: clamp(20px, 4vw, 26px) !important;
  font-weight: 600;
}
.competitiveContainer > div > div > h2 {
  color: #000;
  font-size: clamp(16px, 4vw, 20px) !important;
  font-weight: 600;
}
.competitiveContainer > div > div > p {
  color: #000;
  font-family: lightThicker !important ;
  font-size: clamp(16px, 4vw, 20px) !important;
  font-weight: 400;
}
.table {
  border-collapse: collapse;
  margin-bottom: 30px;
  margin-top: 20px;
}
.table > tr > th {
  border: 1px solid #ba1e24;
  padding: 15px 40px;
  color: #ba1e24;
  font-size: 20px;
  width: 250px;
}
.table > tr > td {
  font-family: lightThicker !important ;
  border: 1px solid #ba1e24;
  padding: 15px 40px;
  font-size: 20px;
  width: 900px;
}
.season {
  padding: 50px 0px;
  background-color: #262626 !important;
}
.season > div {
  width: 80%;
  margin: auto;
}
.seasonTableOne {
  border-collapse: collapse;
  margin-bottom: 30px;
  margin-top: 20px;
}
.seasonTableOne > tr > th {
  border: 1px solid #fff;
  padding: 15px 40px;
  color: #fff;
  font-size: clamp(16px, 4vw, 20px);
  width: 450px;
}

.seasonTableOne > tr > td {
  font-family: lightThicker !important ;
  border: 1px solid #fff;
  padding: 15px 40px;
  font-size: clamp(16px, 4vw, 20px);
  color: #fff;
  width: 800px;
}
.seasonTable {
  border-collapse: collapse;
  margin-bottom: 30px;
  margin-top: 20px;
}
.seasonTable > tr > th {
  border: 1px solid #fff;
  padding: 15px 40px;
  color: #fff;
  font-size: clamp(16px, 4vw, 20px);
  width: 250px;
}

.seasonTable > tr > td {
  font-family: lightThicker !important ;
  border: 1px solid #fff;
  padding: 15px 40px;
  font-size: clamp(16px, 4vw, 20px);
  color: #fff;
  width: 1000px;
}
.season > div > h1 {
  color: #fff !important;
  font-size: clamp(20px, 4vw, 26px);
  font-weight: 600;
}
.season > div > p {
  color: #fff !important;
  font-family: lightThicker !important ;
  font-size: clamp(16px, 4vw, 20px);
  font-weight: 400;
}
.bottom {
  padding: 50px 0px;
  background-color: #ba1e24;
  text-align: center;
}
.bottom > h1 {
  color: #fff;
  font-size: clamp(30px, 4vw, 54px) !important;
  font-weight: 700;
  margin-bottom: 20px;
}
.bottom > p {
  color: #fff;
  text-align: center;
  font-size: clamp(16px, 4vw, 20px) !important;
  font-family: lightThicker !important;
}
.bottom > button {
  margin-top: 50px;
  color: #fff;
  font-size: clamp(18px, 4vw, 24px) !important;
  font-weight: 600;
  padding: 20px;
  background: linear-gradient(0deg, #000 0%, #000 100%), #fff;
  border: none;
  cursor: pointer;
}
.bottom > button > a {
  text-decoration: none !important;
  color: inherit !important;
}
.backgroundBanner {
  display: flex;
  width: 100%;
  height: 88px;
  overflow: hidden;
}
@media screen and (max-width: 1200px) {
  .competitiveContainer > div {
    width: 90%;
  }
  .season > div {
    width: 90%;
  }
}
@media screen and (max-width: 600px) {
  .band_img_div_comp {
    width: 100%;
    padding: 0 !important;
    overflow: hidden;
   }
   
   .band_img_div_comp > img {
     width: 280% !important; 
     height: 50px !important;
     margin-left: -50px;
   }
  .competitiveContainer > div {
    padding: 20px 0px 0px;
  }
  .competitiveContainer > div > div {
    margin-bottom: 20px;
  }
  .table > tr > td {
    padding: 5px 10px;
    font-size: 16px;
  }
  .table > tr > th {
    padding: 5px 10px;
    font-size: 16px;
  }
  .seasonTableOne > tr > th {
    font-size: 16px;
    padding: 5px 10px;
  }
  .seasonTableOne > tr > td {
    font-size: 16px;
    padding: 5px 10px;
  }
  .seasonTable > tr > th {
    font-size: 16px;
    padding: 5px 10px;
  }
  .seasonTable > tr > td {
    font-size: 16px;
    padding: 5px 10px;
  }
  .backgroundBanner {
    background-size: cover;
    height: 40px;
    overflow: hidden;
  }
  .season {
    padding: 20px 0px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/categories/competitive.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,UAAU;EACV,sBAAsB;AACxB;AACA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,iCAAiC;EACjC,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,4CAA4C;EAC5C,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,4CAA4C;EAC5C,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,qCAAqC;EACrC,4CAA4C;EAC5C,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,YAAY;AACd;AACA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,oCAAoC;AACtC;AACA;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,sBAAsB;EACtB,kBAAkB;EAClB,iCAAiC;EACjC,WAAW;EACX,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,sBAAsB;EACtB,kBAAkB;EAClB,iCAAiC;EACjC,WAAW;EACX,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,iCAAiC;EACjC,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,qCAAqC;EACrC,iCAAiC;EACjC,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,4CAA4C;EAC5C,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,4CAA4C;EAC5C,oCAAoC;AACtC;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,4CAA4C;EAC5C,gBAAgB;EAChB,aAAa;EACb,2DAA2D;EAC3D,YAAY;EACZ,eAAe;AACjB;AACA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,WAAW;IACX,qBAAqB;IACrB,gBAAgB;GACjB;;GAEA;KACE,sBAAsB;KACtB,uBAAuB;KACvB,kBAAkB;GACpB;EACD;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".competitiveContainer {\n  width: 100%;\n}\n.competitiveContainer > img {\n  width: 100%;\n  object-fit: cover;\n  height: fit-content;\n}\n.competitiveContainer > div {\n  padding: 50px 0px 0px 0px;\n  margin: auto;\n  width: 80%;\n  background-color: #fff;\n}\n.band_img_div_comp {\n  width: 100%;\n}\n\n.band_img_div_comp > img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.desc_text{\n  color: #fff !important;\n  font-family: lightThicker !important;\n  font-size: clamp(16px, 4vw, 20px);\n  font-weight: 400;\n}\n.competitiveContainer > div > div {\n  margin-bottom: 50px;\n}\n\n.competitiveContainer > div > div > h1 {\n  color: #000;\n  font-size: clamp(20px, 4vw, 26px) !important;\n  font-weight: 600;\n}\n.competitiveContainer > div > div > h2 {\n  color: #000;\n  font-size: clamp(16px, 4vw, 20px) !important;\n  font-weight: 600;\n}\n.competitiveContainer > div > div > p {\n  color: #000;\n  font-family: lightThicker !important ;\n  font-size: clamp(16px, 4vw, 20px) !important;\n  font-weight: 400;\n}\n.table {\n  border-collapse: collapse;\n  margin-bottom: 30px;\n  margin-top: 20px;\n}\n.table > tr > th {\n  border: 1px solid #ba1e24;\n  padding: 15px 40px;\n  color: #ba1e24;\n  font-size: 20px;\n  width: 250px;\n}\n.table > tr > td {\n  font-family: lightThicker !important ;\n  border: 1px solid #ba1e24;\n  padding: 15px 40px;\n  font-size: 20px;\n  width: 900px;\n}\n.season {\n  padding: 50px 0px;\n  background-color: #262626 !important;\n}\n.season > div {\n  width: 80%;\n  margin: auto;\n}\n.seasonTableOne {\n  border-collapse: collapse;\n  margin-bottom: 30px;\n  margin-top: 20px;\n}\n.seasonTableOne > tr > th {\n  border: 1px solid #fff;\n  padding: 15px 40px;\n  color: #fff;\n  font-size: clamp(16px, 4vw, 20px);\n  width: 450px;\n}\n\n.seasonTableOne > tr > td {\n  font-family: lightThicker !important ;\n  border: 1px solid #fff;\n  padding: 15px 40px;\n  font-size: clamp(16px, 4vw, 20px);\n  color: #fff;\n  width: 800px;\n}\n.seasonTable {\n  border-collapse: collapse;\n  margin-bottom: 30px;\n  margin-top: 20px;\n}\n.seasonTable > tr > th {\n  border: 1px solid #fff;\n  padding: 15px 40px;\n  color: #fff;\n  font-size: clamp(16px, 4vw, 20px);\n  width: 250px;\n}\n\n.seasonTable > tr > td {\n  font-family: lightThicker !important ;\n  border: 1px solid #fff;\n  padding: 15px 40px;\n  font-size: clamp(16px, 4vw, 20px);\n  color: #fff;\n  width: 1000px;\n}\n.season > div > h1 {\n  color: #fff !important;\n  font-size: clamp(20px, 4vw, 26px);\n  font-weight: 600;\n}\n.season > div > p {\n  color: #fff !important;\n  font-family: lightThicker !important ;\n  font-size: clamp(16px, 4vw, 20px);\n  font-weight: 400;\n}\n.bottom {\n  padding: 50px 0px;\n  background-color: #ba1e24;\n  text-align: center;\n}\n.bottom > h1 {\n  color: #fff;\n  font-size: clamp(30px, 4vw, 54px) !important;\n  font-weight: 700;\n  margin-bottom: 20px;\n}\n.bottom > p {\n  color: #fff;\n  text-align: center;\n  font-size: clamp(16px, 4vw, 20px) !important;\n  font-family: lightThicker !important;\n}\n.bottom > button {\n  margin-top: 50px;\n  color: #fff;\n  font-size: clamp(18px, 4vw, 24px) !important;\n  font-weight: 600;\n  padding: 20px;\n  background: linear-gradient(0deg, #000 0%, #000 100%), #fff;\n  border: none;\n  cursor: pointer;\n}\n.bottom > button > a {\n  text-decoration: none !important;\n  color: inherit !important;\n}\n.backgroundBanner {\n  display: flex;\n  width: 100%;\n  height: 88px;\n  overflow: hidden;\n}\n@media screen and (max-width: 1200px) {\n  .competitiveContainer > div {\n    width: 90%;\n  }\n  .season > div {\n    width: 90%;\n  }\n}\n@media screen and (max-width: 600px) {\n  .band_img_div_comp {\n    width: 100%;\n    padding: 0 !important;\n    overflow: hidden;\n   }\n   \n   .band_img_div_comp > img {\n     width: 280% !important; \n     height: 50px !important;\n     margin-left: -50px;\n   }\n  .competitiveContainer > div {\n    padding: 20px 0px 0px;\n  }\n  .competitiveContainer > div > div {\n    margin-bottom: 20px;\n  }\n  .table > tr > td {\n    padding: 5px 10px;\n    font-size: 16px;\n  }\n  .table > tr > th {\n    padding: 5px 10px;\n    font-size: 16px;\n  }\n  .seasonTableOne > tr > th {\n    font-size: 16px;\n    padding: 5px 10px;\n  }\n  .seasonTableOne > tr > td {\n    font-size: 16px;\n    padding: 5px 10px;\n  }\n  .seasonTable > tr > th {\n    font-size: 16px;\n    padding: 5px 10px;\n  }\n  .seasonTable > tr > td {\n    font-size: 16px;\n    padding: 5px 10px;\n  }\n  .backgroundBanner {\n    background-size: cover;\n    height: 40px;\n    overflow: hidden;\n  }\n  .season {\n    padding: 20px 0px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
